<script>
    import { getBillingStatus } from "../../../../../Utils/utilFunctions.svelte";

    import { TableComponentContainer } from "../../../../Common/index.svelte";

    export let row = {},
        showSideBorder = true;

    $: sideBorderColor = _getSideBorderColor(row);

    // HELPER FUNCTIONS
    const _getSideBorderColor = (data = {}) => {
        if (!data || !data.hasOwnProperty("billingStatus")) return "";
        return getBillingStatus(data.billingStatus, "color");
    };
</script>

<TableComponentContainer
    customContainerStyle={`${showSideBorder ? `box-shadow: inset 10px 0 0 0 ${sideBorderColor}` : ""}`}
>
    <input
        type="checkbox"
        name="selectCheckbox"
        id="selectCheckBoxId{row.id}"
        class="checkbox checkbox-primary checkbox-xs cursor-pointer rounded-md"
    />
</TableComponentContainer>
